import axios from "axios";
/**
 * Archivo que contiene una estructura personalizada para realizar las llamadas http con axios
 *
 * @package    QualtiaApp
 * @author     Ismael Najera  <ismael.najera@qualtia.com>
 * @version    1.0(0.0.1)
 * @date      01/01/2024
 */

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

axios.interceptors.request.use(config => {
    config.headers['x-api-key'] = process.env.REACT_APP_API_KEY.replace(/"/g, '').trim();
    console.log("|" + process.env.REACT_APP_API_KEY + "|");
    return config;
    }, error => {
        return Promise.reject(error);
});

// crea un interceptor de respuesta para comprobar si hay 401
axios.interceptors.response.use (
    response => response,
    error => {
        if(error.response) {
            const {status} = error.response;
        }        
        return Promise.reject(error);
    }
);

// crea una instancia predeterminada de axios
const instance = axios.create({
    responseType: "json",
});

//#region métodos crudos genéricos
instance.getData = (url, needsAuth) => {    
    const requestOptions = needsAuth === true || needsAuth === undefined ? { headers: authHeader() } : {};
    return new Promise((resolve, reject) => {
        axios.get(url, requestOptions)
            .then(res => {
                resolve(res.data);
            })
            .catch(res => {
                reject(formatReject(res));
            })
    });
}

instance.postData = (url, data, needsAuth) => {
    const requestOptions = needsAuth === true || needsAuth === undefined ? { headers: authHeader() } : {};
    return new Promise((resolve, reject) => {
        axios.post(url, data, requestOptions)
            .then(res => {
                resolve(res.data);
            })
            .catch(res => {
                reject(formatReject(res));
            })
    });
}

instance.putData = (url, data, needsAuth) => {
    const requestOptions = needsAuth === true || needsAuth === undefined ? { headers: authHeader() } : {};
    return new Promise((resolve, reject) => {
        axios.put(url, data, requestOptions)
            .then(res => {
                resolve(res.data);
            })
            .catch(res => {
                reject(formatReject(res));
            })
    });
}

instance.deleteData = (url) => {
    const requestOptions = { headers: authHeader() }; // deletes always need security
    return new Promise((resolve, reject) => {
        axios.delete(url, requestOptions)
            .then(res => {
                resolve(res.data);
            })
            .catch(res => {
                reject(formatReject(res));
            })
    });
}

function formatReject(res) {    
    if(res === null)
        return "error";        
    // normal operation
    if(res.response) {
        if(Array.isArray(res.response.data)) {
            let m = res.response.data.map((o, idx) => {
                return o.description;
            });
            return m.join("\n");
        }    
        return res.response.data;
    }
    else if (res.request) {
        return "network error";
    }
    else
        return "error";
    
}
//#endregion

export default instance;

// devolver encabezado de autorización con token jwt
export function authHeader() {
    let info = localStorage.getItem('user_info');
    let user = info !== null ? JSON.parse(info) : null;
    if (user && user.token) {
        return { 
            'Authorization': 'Bearer ' + user.token,
            'Content-Type': 'application/json'
         };
    } else {
        return {'Content-Type': 'application/json'};
    }
}